import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiUrl } from '../utils/environment';

export const feedSlice = createApi({
    reducerPath: 'feedApi',
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers, { getState }) => {
            headers.set('accept', 'application/json');
            const token = getState().auth.token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        toggleLike: builder.mutation({
            query: ({ id, type }) => ({
                url: `/${type}/${id}/likes`,
                method: 'POST',
            }),
        }),
    }),
});

export const { useToggleLikeMutation } = feedSlice;
